export const environment = {
  production: false,
  //baseUrl: 'https://localhost:44394/',
  baseUrl: 'https://sweelxelkjop26api.azurewebsites.net/',
  langJsonPath: '/assets',
  ImagePath: '/assets/images',
  seDomains: ['sweelxelkjop26.azurewebsites.net', 'sverige.electroluxcashback.se'],
  dkDomains: ['sweelxelkjop26-dk.azurewebsites.net', 'danmark.aegcashback.dk'],
  noDomains: ['sweelxelkjop26-no.azurewebsites.net', 'norge.aegcashback.no'],
  fiDomains: ['sweelxelkjop26-fi.azurewebsites.net', 'suomi.aegcashback.fi'],
  googleAnalytics: {
    domain: 'none',
    trackingId: 'UA-160739827-10'
  },
  authConfig: {
    instance: 'https://login.microsoftonline.com/',
    tenant: 'loyaltic.com',
    tenentId: 'd86b49fe-9dda-48c2-80cd-d048429368f3',
    clientId: '35a290fb-c31e-469d-bb10-9c163c9be65a'
  }
};
